import ReactDOM from 'react-dom';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import e from '../style.module.css';
import apiService from 'Services/apiService';
import AlertNotification, {IAlert} from "components/common/AlertNotification/AlertNotification";
import { DownloadDOC } from 'Utils/Fn/DownloadDOC';
import { formatDate } from "Utils/Fn/DateParser";

import './style.css'

function Modalmarbete({ show, mData, handleClose }: IModal) {
  const [alert, setAlert] =  useState<IAlert>({ show: false, title: '', details: '', variant: 'Danger' });
  const [disableBtn, setDisableBtn] = useState(false);

  const [marbeteData, setMarbeteData] = useState({
    nombre: '',
    poliza: '',
    aseguradora: '',
    fechaEmision: '',
    fechaVencimiento: '',
    marca: '',
    modelo: '',
    anio: '',
    tipo: '',
    chasis: '',
    placa: '',
    urlImg: ''
  })

  useEffect(() => {
    if (!show) return
    apiService({
      name: 'getMarbeteDetailsInd',
      queryParams: {
        _codigoCliente: JSON.parse(localStorage.getItem('cliCod') || 'null'),
        _numeroChasis: mData.chasis
      },
      onSuccess: ({response}) => {
        const data = response[0]
        setMarbeteData({
          nombre: data.nombre || '',
          poliza: mData.numPoliza || '[POLIZA]',
          aseguradora: data.aseguradora || '[NOMBRE]',
          fechaEmision: formatDate(data.fechaEmision) || '[Fecha emisión]',
          fechaVencimiento: formatDate(data.fechaVencimiento) || '[Fecha vencimiento]',
          marca: data.marca || '[Marca]',
          modelo: data.modelo || '[modelo]',
          anio: data.anio || '[Año]',
          tipo: data.tipo || '[Tipo vehículo]',
          chasis: data.chasis || '[Chasis]',
          placa: data.placa || '[PLACA]',
          urlImg: data.logoAseguradora || ''
        })
      },
      onError: (error) => {
        console.error('Error:', error);
        setAlert({
          show: true,
          title: 'Error al obtener los datos para flotilla de vehiculos',
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
      }
    });
  }, [show]);

  const resetAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };


  // Descargar marbete
  const download = (data: any) => {
    setDisableBtn(true);
    apiService({
      name: 'GeneraPDFMarbeteInv',
      queryParams: { _numeroChasis: marbeteData.chasis, _codigoCliente: JSON.parse(localStorage.getItem('cliCod') || 'null') },
      onSuccess: (resp) => {
        DownloadDOC(resp, `${marbeteData.chasis}_${marbeteData.nombre}.pdf`)
      },
      onError: (error) => {
        setAlert({
          show: true,
          title: 'Error al intentar descarger el marbete',
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
        setDisableBtn(false);
      }
    });
  };

  const resetModalData = () => {
    setMarbeteData({
      nombre: '',
      poliza: '',
      aseguradora: '',
      fechaEmision: '',
      fechaVencimiento: '',
      marca: '',
      modelo: '',
      anio: '',
      tipo: '',
      chasis: '',
      placa: '',
      urlImg: ''
    });
  };

  return (
    <>
    <Modal
      show={show}
      onHide={()=> {
        resetModalData()
        resetAlert()
        handleClose()
      }}
      dialogClassName="modal-md"
      aria-labelledby="example-custom-modal-styling-title"
      className={e['modal-billing']}
    >
      
      <Modal.Header closeButton>
        <Modal.Title>
          <span className={e.modal_header}>Marbete provisional</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={e.modal_body}>
        <section className={e.section_modal}>
        <div className="container-tag-modal">
          <div className="left-tag-modal">
            <div className="logo-tag-modal">
              <img src={marbeteData.urlImg} alt={`Logo ${marbeteData.aseguradora}`} width="80"/>
            </div>
            <table className="info-tag-modal">
              <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td><strong>Póliza:</strong></td>
                  <td colSpan={2}><strong>{marbeteData.poliza}</strong></td>
                </tr>
                <tr>
                  <td><strong style={{marginRight: '6px'}}>Aseguradora:</strong></td>
                  <td colSpan={3}><strong>{marbeteData.aseguradora}</strong></td>
                </tr>
                <tr>
                  <td>Desde:</td>
                  <td>{marbeteData.fechaEmision}</td>
                  <td>Hasta:</td>
                  <td>{marbeteData.fechaVencimiento}</td>
                </tr>
                <tr>
                  <td>Marca:</td>
                  <td>{marbeteData.marca}</td>
                  <td>Modelo:</td>
                  <td>{marbeteData.modelo}</td>
                </tr>
                <tr>
                  <td>Año:</td>
                  <td>{marbeteData.anio}</td>
                  <td>Tipo:</td>
                  <td>{marbeteData.tipo}</td>
                </tr>
                <tr>
                  <td>Chasis:</td>
                  <td>{marbeteData.chasis}</td>
                  <td>Registro:</td>
                  <td>{marbeteData.placa}</td>
                </tr>
              </tbody>
            </table>
            {/* <div className="right-info-text-ctn">
             <p>[QR]</p> 
            </div>             */}
          </div>

          {/* <div className="right-tag-modal">
            <p>[DatosDeDirección]</p>
            <div className="notes-tag-modal">
              <p><strong>NOTAS:</strong> [NotasAdicionales]</p>
            </div>
          </div> */}
        </div>
        <div className="download-btn-marbete">
          <button
            type="button"
            className="btn btn-link"
            data-bs-toggle="tooltip" data-bs-placement="top" title="Descargar condiciones particulares"
            disabled={disableBtn}
            onClick={() => download('datos')}
          >
            {
              !disableBtn
              ? (<i className="bi bi-download"></i>)
              : (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
            }
          </button>
        </div>
        </section>     
      </Modal.Body>

      <Modal.Footer>
        <Button variant='secondary' onClick={() => {
          resetModalData()
          resetAlert()
          handleClose()
        }}>
          Close
        </Button>
      </Modal.Footer>
      <AlertNotification
          show={alert?.show}
          title= {alert?.title}
          details= {alert?.details}
          variant={alert?.variant}
          onClose={resetAlert}
      />

    </Modal>
  </>
  )
}


export default function ModalPolicies ({ show, handleClose, mData }: IModal) {

  const modalRoot = document.getElementById('modal-root') as HTMLElement;

  return ReactDOM.createPortal(
  <Modalmarbete
    show={show} 
    handleClose={handleClose} 
    mData={mData} 
  />, 
  modalRoot)

}


interface IModal{
  show: boolean;
  mData: any;
  handleClose: () => void;
}